export default {
  common: {
    labels: {
      onlyInstalled: "Solo instalados",
      showMore: "Mostrar más",
      showLess: "Mostrar menos",
      reportDate: "Fecha del informe",
      reportTime: "Hora del informe",
      reportAtGlance: "Informe de un vistazo",
      fleetStatus: "Estado de la flota",
      fleetSize: "Tamaño de la flota",
      totalDevices: "Dispositivos totales",
      addNewAlert: "Agregar nueva alerta",
      addNewRecepient: "Agregar nuevo destinatario",
      selectEVModel: "Seleccionar modelo de VE",
      selectHPModel: "Seleccionar modelo de HP",
      reRunAnalysis: "Volver a ejecutar el análisis",
      devicesWith: "Dispositivos con",
      logout: "Cerrar sesión",
      name: "Nombre",
      email: "Correo electrónico",
      nickname: "Apodo",
      openAsPage: "Abrir como página",
      editDeviceDetails: "Editar detalles del dispositivo",
      manageAlerts: "Administrar alertas",
      noLocation: "No se encontró ubicación para este dispositivo",
      selectDeviceToCompare: "Seleccionar un dispositivo para comparar",
      includeAmbientTemperature: "Incluir temperatura ambiente",
      startDate: "Fecha de inicio",
      endDate: "Fecha de fin",
      thisFieldIsRequired: "Este campo es obligatorio",
      mustBeLessThan50Characters: "Debe tener menos de 50 caracteres",
      numberHasToBeBetween0And100: "El número debe estar entre 0 y 100",
      timeOfDay: "Hora del día",
      indicatesRequiredField: "Indica campo obligatorio",
      editDetails: "Editar detalles",
      noReportAvailable: "No hay informes disponibles para ninguna semana",
      noDataAvailable: "No hay datos disponibles",
      resetView: "Restablecer vista",
      fleetOverview: "Resumen de la flota",
      functionalLocation: "Ubicación funcional",
    },
    words: {
      total: "Total",
      this: "Este",
      all: "Todo",
      watchList: "Lista de seguimiento",
      schedule: "Horario",
      client: "Cliente",
      recepients: "Destinatarios",
      more: "Más",
      devices: "Dispositivos",
      search: "Buscar",
      reset: "Restablecer",
      save: "Guardar",
      language: "Idioma",
      english: "Inglés",
      french: "Francés",
      back: "Atrás",
      clear: "Limpiar",
      to: "a",
      standard: "Estándar",
      commuter: "Commuter",
      nonCommuter: "No commuter",
      edit: "Editar",
      cancel: "Cancelar",
      saveAs: "Guardar como",
      alert: "Alerta",
      last: "Último",
      preferences: "Preferencias",
    },
    messages: {
      success: {
        deviceDetailsSaved: "¡Detalles del dispositivo guardados exitosamente!",
        good: "Bueno",
      },
      warnings: {
        temperatureError: "Error de temperatura",
        temperatureInvestigationWarning: "Activos con alerta de temperatura que pueden requerir investigación",
        missedMessages: "Mensajes perdidos",
        noCommunications: "Sin comunicaciones",
      },
      errors: {},
      filter: {
        filterApplied: "Filtro aplicado correctamente",
        filterRemoved: "Filtro eliminado correctamente",
        filterError: "Error al aplicar el filtro",
      },
    },
    measure: {
      kVA: "kVA",
      kW: "kW",
    },
    times: {
      days: {
        sunday: "Domingo",
        monday: "Lunes",
        tuesday: "Martes",
        wednesday: "Miércoles",
        thursday: "Jueves",
        friday: "Viernes",
        saturday: "Sábado",
      },
      months: {
        january: "Enero",
        february: "Febrero",
        march: "Marzo",
        april: "Abril",
        may: "Mayo",
        june: "Junio",
        july: "Julio",
        august: "Agosto",
        september: "Septiembre",
        november: "Noviembre",
        december: "Diciembre",
        jan: "Ene",
        feb: "Feb",
        mar: "Mar",
        apr: "Abr",
        my: "May",
        jun: "Jun",
        jul: "Jul",
        aug: "Ago",
        sep: "Sep",
        nov: "Nov",
        dec: "Dic",
      },
      time: {
        today: "Hoy",
        second: "Segundo",
        seconds: "Segundos",
        minute: "Minuto",
        minutes: "Minutos",
        hr: "Hora",
        hrs: "Horas",
        day: "Día",
        days: "Días",
        week: "Semana",
        weeks: "Semanas",
        month: "Mes",
        months: "Meses",
        year: "Año",
        years: "Años",
        secondsAge: "Hace unos segundos",
        minutesAge: "Hace unos minutos",
        hoursAgo: "Hace unas horas",
        daysAgo: "Hace unos días",
        weeksAgo: "Hace unas semanas",
        monthsAgo: "Hace unos meses",
        yearsAgo: "Hace unos años",
        last24Hours: "Últimas 24 horas",
        last7Days: "Últimos 7 días",
        last28Days: "Últimos 28 días",
        lastWeek: "Última semana",
        last4Weeks: "Últimas 4 semanas",
        last8Weeks: "Últimas 8 semanas",
        last3Months: "Últimos 3 meses",
        last6Months: "Últimos 6 meses",
        last1Year: "Último año",
        TwentyFourHours: "24 horas",
        SevenDays: "7 días",
        TwentyEightDays: "28 días",
      },
    },
  },
  views: {
    Alerts: {},
    Analytics: {
      mainTitle: "Analítica",
      pageTitle: "Resumen",
      charts: {
        totalPower: {
          title: "Potencia Total",
          xLabel: "Capacidad (kVA)",
          yLabel: "Marca de tiempo",
          bottomLabelMaxCapacity: "Capacidad Máxima Total",
          bottomLabelTotalCapacity: "Capacidad Total Utilizada",
        },
        issues: {
          title: "Problemas",
          xLabel: "Problemas",
          yLabel: "Número de Dispositivos",
          hAxis: {
            HasCapacityUnderLimit: {
              label: "Capacidad Inferior al Límite",
              tooltip: "Activos con capacidad inferior al 15%",
            },
            HasCapacityOverLimit: {
              label: "Capacidad Superior al Límite",
              tooltip: "Activos con capacidad superior al 85%",
            },
            HasMissedMessages: {
              label: "Mensajes Perdidos",
              tooltip: "Activos con mensajes perdidos",
            },
            HasImbalance: {
              label: "Desequilibrio de Fases",
              tooltip: "Activos con desequilibrio máximo > 90%",
            },
            HasCurrentOverLimit: {
              label: "Corriente Superior al Límite",
              tooltip: "Activos con corriente superior al límite",
            },
            HasLowBattery: {
              label: "Batería Baja",
              tooltip: "Activos con batería baja",
            },
            HasNoPower: {
              label: "Sin Energía",
              tooltip: "Activos sin energía",
            },
            HasTemperatureOutsideRange: {
              label: "Temperatura Fuera del Rango",
              tooltip: "Activos con temperatura fuera del rango",
            },
            HasTemperatureOverLimit: {
              label: "Temperatura Superior al Límite",
              tooltip: "Activos con temperatura superior al límite",
            },
            HasTemperatureSenseError: {
              label: "Alerta de Temperatura",
              tooltip: "Activos con alerta de temperatura",
            },
          },
        },
      },
      tables: {
        devices: {
          title: "Dispositivos",
          columns: {
            id: "ID del Dispositivo",
            type: "Tipo de Monitor",
            t_name: "Nombre del Transformador",
            t_size: "Tamaño del Transformador",
            capacity: {
              text: "Capacidad",
              tooltip:
                "% de la capacidad total disponible utilizada. (Corriente Mediana Total * 230/1000) / Porcentaje de Potencia",
            },
            power: {
              text: "Potencia Total",
              tooltip: "La suma total de las mediciones máximas de potencia de todas las fases durante el período.",
            },
            l_message: "Último Mensaje",
          },
        },
      },
    },
    Asset: {
      deviceDetails: {
        transformerName: {
          label: "Nombre del Transformador",
        },
        transformerNo: {
          label: "Número del Transformador",
        },
        transformerSize: {
          label: "Tamaño del Transformador",
        },
        assetId: {
          label: "ID del Activo",
        },
        deviceStatus: {
          label: "Estado del Dispositivo",
        },
        deviceVoltage: {
          label: "Voltaje del Dispositivo",
        },
        installationDate: {
          label: "Fecha de Instalación",
        },
        connectedMPRNs: {
          label: "MPRNs Conectados",
        },
        commuterArea: {
          label: "Área de Conmutación",
        },
      },
      latestMessage: {
        title: "Último Mensaje",
        currentPH1: {
          label: "Corriente PH1",
          suffix: "A",
          helptext: "(Med/Max)",
        },
        currentPH2: {
          label: "Corriente PH2",
          suffix: "A",
          helptext: "(Med/Max)",
        },
        currentPH3: {
          label: "Corriente PH3",
          suffix: "A",
          helptext: "(Med/Max)",
        },
        temperature: {
          label: "Temperatura",
          suffix: "°C",
          helptext: "(Med/Max)",
        },
      },
      calculatedReadings: {
        title: "Lecturas Calculadas",
        totalPower: {
          label: "Potencia Total",
          suffix: "kVA",
        },
        capacity: {
          label: "Capacidad",
          suffix: "%",
        },
        imbalance: {
          label: "Desequilibrio",
          suffix: "%",
        },
        utilization: {
          label: "Utilización",
          suffix: "%",
        },
      },
      tabs: {
        charts: {
          label: "Gráficos",
        },
        messages: {
          label: "Mensajes",
        },
        evAnalysis: {
          label: "Análisis de EV",
        },
        hpAnalysis: {
          label: "Análisis de HP",
        },
      },
      charts: {
        chartConfig1: {
          title: "Seleccionar dispositivo para comparar",
          temp: {
            label: "Temperatura (°C)",
            xAxis: "Marca de Tiempo",
            yAxis: "Temperatura (°C)",
          },
          diff: {
            label: "Temperatura (°C)",
            xAxis: "Marca de Tiempo",
            yAxis: "Temperatura",
          },
          imbalance: {
            label: "Desequilibrio y Corriente Mediana (A)",
            labelDailyStats: "Desequilibrio y Corriente (A)",
            xAxis: "Marca de Tiempo",
            yAxis: "Carga Máxima (A)",
            yBarAxis: "Desequilibrio (%)",
          },
          totalPower: {
            label: "Potencia Total y Corriente Mediana (A)",
            labelDailyStats: "Potencia Total y Corriente (A)",
            xAxis: "Marca de Tiempo",
            yAxis: "Carga Máxima (A)",
            yBarAxis: "Potencia Total (kVA)",
          },
          imbalanceMax: {
            label: "Desequilibrio y Corriente Máxima (A)",
            xAxis: "Marca de Tiempo",
            yAxis: "Carga Máxima",
            yBarAxis: "Desequilibrio",
          },
          totalPowerMax: {
            label: "Potencia Total y Corriente Máxima (A)",
            xAxis: "Marca de Tiempo",
            yAxis: "Carga Máxima (A)",
            yBarAxis: "Potencia Total (kVA)",
          },
        },
      },
      tables: {
        messages: {
          columns: {
            seqNo: {
              text: "N° Secuencia",
            },
            messageTime: {
              text: "Hora del Mensaje",
            },
            missedMessage: {
              text: "Mensaje Perdido",
            },
            lqi: {
              text: "LQI",
            },
            medCurrentPH1: {
              text: "Corriente Mediana PH1",
              suffix: "A",
            },
            maxCurrentPH1: {
              text: "Corriente Máxima PH1",
              suffix: "A",
            },
            medCurrentPH2: {
              text: "Corriente Mediana PH2",
              suffix: "A",
            },
            maxCurrentPH2: {
              text: "Corriente Máxima PH2",
              suffix: "A",
            },
            medCurrentPH3: {
              text: "Corriente Mediana PH3",
              suffix: "A",
            },
            maxCurrentPH3: {
              text: "Corriente Máxima PH3",
              suffix: "A",
            },
            maxTemp: {
              text: "Temp. Máxima",
              suffix: "°C",
            },
            medTemp: {
              text: "Temp. Mediana",
              suffix: "°C",
            },
            capacity: {
              text: "Capacidad",
              suffix: "%",
              tooltip:
                "% de la capacidad total disponible utilizada. (Corriente Mediana Total * 230/1000) / Porcentaje de Potencia",
            },
            imbalance: {
              text: "Desequilibrio",
              suffix: "%",
              tooltip:
                "Desequilibrio de corriente entre fases. Diferencia máxima entre la fase y la corriente promedio / Corriente promedio (%) *solo para 3 fases",
            },
          },
        },
      },
    },
    Assets: {
      pageTitle: "Resumen de Dispositivos",
      deviceCoverage: "Ver Cobertura de Dispositivos",
      charts: {
        capacity: {
          title: "Capacidad",
          tooltip:
            "El análisis de capacidad mide la cantidad de capacidad utilizada en cada transformador y la estratifica en sobrecargada, normal o bajo rendimiento.",
          header: {
            capacity: "Capacidad",
            numberOfDevices: "Número de Dispositivos",
          },
          data: {
            underperforming: {
              text: "Bajo Rendimiento",
              message: "Dispositivos por debajo del límite de corriente - Menos del 15% de Capacidad",
            },
            normal: {
              text: "Normal",
              message: "Dispositivos con corriente óptima - Entre el 15% y el 85% de Capacidad",
            },
            overutilised: {
              text: "Sobrecargada",
              message: "Dispositivos por encima del límite de corriente - Más del 85% de Capacidad",
            },
          },
        },
        imbalance: {
          title: "Desequilibrio",
          tooltip:
            "El desequilibrio mide la cantidad de desequilibrio en las 3 fases utilizadas en cada transformador y lo estratifica en desequilibrado o normal.",
          header: {
            imbalanceStatus: "Estado de Desequilibrio",
            numberOfDevices: "Número de Dispositivos",
          },
          data: {
            normal: {
              label: "Normal",
              message: "Dispositivos sin desequilibrio.",
            },
            imbalance: {
              label: "Desequilibrio",
              message: "Dispositivos con desequilibrio.",
            },
          },
        },
        powerChange: {
          title: "Cambio de Potencia",
          tooltip:
            "El cambio de potencia mide la cantidad de cambio de potencia en cada transformador y lo estratifica en anormal o normal.",
          header: {
            powerChangeStatus: "Estado de Cambio de Potencia",
            numberOfDevices: "Número de Dispositivos",
          },
          data: {
            normal: {
              label: "Normal",
              message: "Dispositivos sin cambio de potencia anormal.",
            },
            abnormal: {
              label: "Anormal",
              message: "Dispositivos con cambio de potencia anormal.",
            },
          },
        },
        batteryStatus: {
          title: "Estado de la Batería",
          tooltip:
            "Muestra el estado de la batería de todos los dispositivos y lo estratifica en alto, bajo o desconocido.",
          header: {
            batteryStatus: "Estado de la Batería",
            numberOfDevices: "Número de Dispositivos",
          },
          data: {
            highBattery: {
              label: "Batería Alta",
              message: "Dispositivos con batería alta.",
            },
            lowBattery: {
              label: "Batería Baja",
              message: "Dispositivos con batería baja.",
            },
            unknownBattery: {
              label: "Batería Desconocida",
              message: "Dispositivos con batería desconocida.",
            },
          },
        },
        devicesCommunication: {
          title: "Comunicación de Dispositivos",
          tooltip:
            "Muestra la comunicación de todos los dispositivos y lo estratifica en comunicado, sin comunicación o mensajes perdidos.",
          header: {
            connectivity: "Conectividad",
            numberOfDevices: "Número de Dispositivos",
          },
          data: {
            communicated: {
              label: "Comunicado",
              message: "Dispositivos sin mensajes perdidos",
            },
            noCommunications: {
              label: "Sin Comunicación",
              message: "Dispositivos no comunicados en las últimas 24 horas",
            },
            missedMessages: {
              label: "Mensajes Perdidos",
              message: "Dispositivos con mensajes perdidos",
            },
          },
        },
        devicesStatus: {
          title: "Estado de los Dispositivos",
          tooltip:
            "Muestra el estado/problemas de todos los dispositivos y lo estratifica en sin problema, problema de desequilibrio de fase, temperatura fuera de rango, corriente por encima del límite, problema de comunicación, problema de energía, problema de sensor de temperatura, temperatura por encima del límite o problema de batería.",
          header: {
            deviceStatus: "Estado del Dispositivo",
            numberOfDevices: "Número de Dispositivos",
          },
          data: {
            noIssue: {
              label: "Sin Problema",
              message: "Dispositivos sin problemas.",
            },
            phaseImbalance: {
              label: "Desequilibrio de Fase",
              message: "Dispositivos con desequilibrio máximo > 90%",
            },
            temperatureAlert: {
              label: "Alerta de Temperatura",
              message: "Dispositivos con alerta de temperatura que pueden requerir investigación",
            },
            currentOverlimit: {
              label: "Corriente por Encima del Límite",
              message: "Dispositivos con corriente por encima del límite.",
            },
            communicationProblem: {
              label: "Problema de Comunicación",
              message: "Dispositivos con problema de comunicación.",
            },
            noPower: {
              label: "Sin Energía",
              message: "Dispositivos con problema de energía.",
            },
            lowBattery: {
              label: "Batería Baja",
              message: "Dispositivos con problemas de batería.",
            },
          },
        },
      },
      tables: {
        devices: {
          title: "",
          filters: {
            primary: {},
            secondary: {
              list_checkbox: {
                label: "Tipo de Transformador",
              },
              flags: {
                temperatureOverlimit: {
                  label: "Temperatura Fuera de Límite",
                },
                currentOverlimit: {
                  label: "Corriente por Encima del Límite",
                },
              },
              range: {
                transformerSize: {
                  label: "Tamaño del Transformador",
                },
                maxCurrentPH1: {
                  label: "Corriente Máxima PH1",
                },
                maxCurrentPH2: {
                  label: "Corriente Máxima PH2",
                },
                maxCurrentPH3: {
                  label: "Corriente Máxima PH3",
                },
                maxTemperature: {
                  label: "Temperatura Máxima",
                },
              },
            },
          },
          columns: {
            deviceId: {
              text: "ID del Dispositivo",
            },
            monitorType: {
              text: "Tipo de Monitor",
            },
            deviceName: {
              text: "Nombre",
            },
            powerRating: {
              text: "Tamaño del Transformador",
            },
            totalPower: {
              text: "Potencia Total",
              tooltip: "La suma de las medidas máximas de potencia de todas las fases durante el período.",
            },
            maxCapacity: {
              text: "Capacidad Máxima (%)",
              tooltip:
                "% de la capacidad total disponible utilizada. (Corriente Máxima Total * 230/1000) / Tamaño del Transformador (%)",
            },
            maxImbalance: {
              text: "Desequilibrio Máximo (%)",
              tooltip:
                "Desequilibrio de corriente entre fases. Diferencia máxima entre la fase y la corriente promedio / Corriente promedio (%) *solo para 3 fases",
            },
            current0Max: {
              text: "Corriente Máxima PH1-PH2-PH3",
            },
            maxTemperature: {
              text: "Temperatura Máxima",
            },
            isCommuterArea: {
              text: "Zona de Pasajeros",
            },
            isWatchlisted: {
              text: "",
            },
            moreActions: {
              text: "",
              labels: ["Editar Detalles"],
            },
          },
        },
      },
    },
    AssetSnapshotView: {},
    CoverageChecker: {},
    Device: {},
    DeviceCoverage: {},
    DeviceHome: {},
    Error: {},
    EVModelling: {
      charts: {
        maxEVSupported: {
          title: "Máximo de Vehículos Eléctricos Soportados",
          labels: {
            maxEVs: "Máximo de Vehículos Eléctricos",
            numberOfDevices: "Número de Dispositivos",
          },
        },
        maxHPSupported: {
          title: "Máximo HP Compatible",
          labels: {
            maxHP: "Máximo HPs",
            numberOfDevices: "Número de Dispositivos",
          },
        },
        firstYearOverCapacity: {
          title: "Primer Año con Capacidad Excedida",
          labels: {
            xLabel: "Primer Año del Problema",
            yLabel: "Cantidad de Dispositivos",
          },
        },
      },
      tables: {
        deviceEVMTable: {
          title: "",
          columns: {
            deviceId: {
              text: "ID del Dispositivo",
            },
            maxEVs: {
              text: "Máximo de Vehículos Eléctricos",
            },
            maxEVHour: {
              text: "Hora del Máximo de Vehículos Eléctricos",
            },
            firstYearOverCapacity: {
              text: "Primer Año con Capacidad Excedida",
            },
            maxLoadDay: {
              text: "Día de Máxima Carga",
            },
            minHeadroom: {
              text: "Mínimo de Margen de Carga",
            },
            maxLoad: {
              text: "Máxima Carga",
            },
            maxLoadHour: {
              text: "Hora de Máxima Carga",
            },
          },
        },
      },
    },
    Home: {},
    HPModelling: {},
    Journey: {},
    Journeys: {},
    Location: {},
    LocationList: {},
    PoiReport: {},
    PowerdataAlerts: {
      title: "",
      tabs: {
        activeAlerts: {
          label: "Alertas Activas",
        },
        manageAlerts: {
          label: "Administrar Alertas",
        },
      },
      alert: {
        alarm: {
          label: "Alarma",
        },
        maxCurrentPH1: {
          label: "Corriente Máxima F1",
        },
        medCurrentPH1: {
          label: "Corriente Media F1",
        },
        maxCurrentPH2: {
          label: "Corriente Máxima F2",
        },
        medCurrentPH2: {
          label: "Corriente Media F2",
        },
        maxCurrentPH3: {
          label: "Corriente Máxima F3",
        },
        medCurrentPH3: {
          label: "Corriente Media F3",
        },
        maxTemperature: {
          label: "Temperatura Máxima",
        },
        medTemperature: {
          label: "Temperatura Media",
        },
        imbalance: {
          label: "Desequilibrio",
        },
        totalPower: {
          label: "Potencia Total",
        },
      },
      tables: {
        alerts: {
          columns: {
            alertId: {
              text: "ID de Alerta",
            },
            deviceId: {
              text: "ID del Dispositivo",
            },
            deviceType: {
              text: "Tipo de Dispositivo",
            },
            triggerField: {
              text: "Campo de Disparo",
            },
            triggerValue: {
              text: "Valor de Disparo",
            },
            triggerOperator: {
              text: "Operador de Disparo",
            },
            moreActions: {
              text: "",
              labels: ["Administrar Destinatarios", "Editar Detalles", "Eliminar"],
            },
          },
        },
        activeAlerts: {
          columns: {
            alertId: {
              text: "ID de Alerta",
            },
            deviceId: {
              text: "ID del Dispositivo",
            },
            fullName: {
              text: "Nombre",
            },
            deviceType: {
              text: "Tipo de Dispositivo",
            },
            triggerField: {
              text: "Campo de Disparo",
            },
            triggerValue: {
              text: "Valor de Disparo",
            },
            actualValue: {
              text: "Valor Actual",
            },
            triggerDate: {
              text: "Fecha de Disparo",
            },
          },
        },
      },
    },
    PowerdataReports: {
      header: {},
    },
    PowerdataReportView: {},
    Profile: {
      userInformation: {
        title: "Información del Usuario",
      },
      preferences: {
        language: "Preferencias de Idioma",
        theme: "Preferencias de Tema",
      },
      managePreferences: {
        title: "Administrar Preferencias",
        defaultTab: "Pestaña Predeterminada",
        manageSections: "Administrar Secciones",
        arrangeSections: "Organizar Secciones",
      },
    },
    Reports: {},
    Snapshot: {},
  },
  components: {
    AlertsTemplate: {
      labels: {
        deviceType: "Tipo de dispositivo",
        triggerField: "Campo de activación",
        triggerValue: "Valor de activación",
        device: "Dispositivo",
        triggerOperator: "Operador de activación",
      },
    },
    AreaChartVT: {},
    AssetSnapshot: {},
    ColumnChartVT: {},
    ComboChart: {},
    ComboChartVT: {},
    DataTableVT: {},
    DaysSelector: {},
    DialogVT: {
      contactVT: "Por favor, contacte a VT...",
      desc: "Tiene acceso limitado a las funciones disponibles en la aplicación. Por favor, contacte a VT para obtener más información sobre las funciones ofrecidas.",
    },
    DiffAreaChart: {},
    DiffChart: {},
    DistributionBarVT: {},
    EditAssetDetails: {},
    EditLocationDetails: {},
    Error: {},
    EVModelDetails: {},
    EVModelEditDetails: {
      labels: {
        selectModel: "Seleccionar Modelo",
        selectDayType: "Seleccionar Tipo de Día",
        useCommuterStatus: "Usar Estado de Viajero",
        mostRecentWeekday: "Día Laboral más Reciente",
        mostRecentWeekdayTooltip: "* Para el cual hay 24 horas de datos de mensajes",
        maxAnnualLoadDay: "Día de Mayor Carga Anual",
        evModelDetails: "Detalles del Modelo de Vehículo Eléctrico",
        chooseModelName: "Elegir Nombre del Modelo",
        modelName: "*Nombre del Modelo",
        indicatesRequiredField: "*Indica campo obligatorio",
        chargeRateWeekday: "Tasa de Carga (Día Laboral)",
        chargeRateWeekend: "Tasa de Carga (Fin de Semana)",
        chargeDurationWeekday: "Duración de Carga, Día Laboral (Hrs)",
        chargeDurationWeekend: "Duración de Carga, Fin de Semana (Hrs)",
        ratioOfHigh1: "Proporción de Cargadores de Alta Potencia (7Kw) a Baja Potencia (3Kw) (%) [por VE = ",
        ratioOfHigh2: " kVa]",
        ratioOfBEV: "Proporción de Vehículos Eléctricos Puros a Híbridos Enchufables (%)",
        confidenceLevel: "Nivel de Confianza % (Distribución Binomial)",
        percentageOfPeopleWhoPurchase: "Porcentaje de personas que compran un coche nuevo por año (%)",
        modifyProbalities: "Modificar Probabilidades",
        changeProbabilityDistribution: "Cambiar Distribución de Probabilidades",
      },
      charts: {
        evForecast: {
          title: "Predicción de la Proporción de Ventas de Vehículos Eléctricos por Año (hasta 2030)",
          label: "Predicción de Ventas de Vehículos Eléctricos",
          xAxis: "Año",
          yAxis: "% de Vehículos Eléctricos",
          vAxes: {
            title: "% de Ventas de Vehículos Eléctricos",
          },
          hAxis: {
            title: "Año",
          },
        },
        cumulProbChart: {
          title: "Probabilidad de que un cargador de VE esté consumiendo energía por hora",
          label: "Análisis de Probabilidad Acumulada",
          xAxis: "Hora del Día",
          yAxis: "Probabilidad de Carga",
          vAxes: {
            title: "Probabilidad de Carga",
          },
          chartLabels: {
            0: "Marca de Tiempo",
            1: "Probabilidad de Carga (%)",
          },
        },
        powerLoadDataOnly: {
          title: {
            1: "Análisis de Carga/Disponibilidad de Energía del Transformador [ ",
            2: " ]",
          },
          label: "Carga del Transformador",
          yLabel: "Hora del Día",
          xLabel: "Carga (kVa)",
          vAxes: {
            0: { title: "Carga (kVa)" },
            1: { title: "Disponibilidad (kVa)" },
          },
          chartLabels: {
            0: { title: "Hora del Día" },
            1: { title: "Carga Total" },
            2: { title: "Disponibilidad" },
            3: { title: "Carga Máxima" },
          },
        },
        evModelChart: {
          title:
            "Número Máximo Adicional de Cargadores de VE en este Transformador (Análisis de Distribución Binomial)",
          label: "Análisis de Disponibilidad de Cargadores de VE",
          xAxis: "Hora del Día",
          yAxis: "# Cargadores de VE",
          vAxes: {
            0: { title: "# Cargadores de VE" },
            1: { title: "MAX_CARGADORES = " },
          },
          chartLabels: {
            0: { title: "Marca de Tiempo" },
            1: { title: "Número Máximo de Cargadores" },
            2: { title: "Número Máximo de VE" },
          },
        },
        totalNewEVCharge: {
          title: "Predicción de Nuevos Vehículos Eléctricos por Año en este Transformador",
          label: "Ventas Anuales de Vehículos Eléctricos Calculadas",
          xAxis: "Año",
          yAxis: "# Total de Nuevos Cargadores de VE",
          vAxes: {
            title: "# Total de Nuevos Cargadores de VE",
          },
          hAxis: {
            title: "Año",
          },
          chartLabels: {
            0: { title: "Año" },
            1: { title: "Número de Vehículos Eléctricos" },
            2: { title: "Primer año con capacidad excedida" },
          },
        },
      },
    },
    HPModelEditDetails: {
      filters: {
        modelName: {
          label: "Seleccionar Modelo",
        },
        dayType: {
          label: "Seleccionar Tipo de Día",
          tooltip: "Elige el día más reciente o el día de mayor carga del año",
          mostRecentWeekday: "Día Laboral más Reciente",
          maxAnnualLoadDay: "Día de Mayor Carga Anual",
          mostRecentWeekdayTooltip: "* Para el cual hay 24 horas de datos de mensajes",
        },
        extremeScenerio: {
          label: "Escenario Extremo ('1 en 20')",
          tooltip: "Modelos para picos inusualmente fríos de invierno (por ejemplo, -5 grados)",
        },
      },
      title: "Detalles del Modelo de Bomba de Calor de Alto Rendimiento",
      subTitle: "Nombre del Modelo",
      HPModelEdit: {
        labels: {
          chooseModelName: "Elegir Nombre del Modelo",
          ratioOfNewBuildExistingHomes: {
            title: "Proporción de Viviendas de Obra Nueva vs. Existentes (%)",
            labelA: "Obra Nueva",
            labelB: "Existente",
          },
          ratioOfDetachedvsSemi: {
            title: "Proporción de Viviendas Unifamiliares vs. Adosadas o en Hilera (%)",
            labelA: "Unifamiliares",
            labelB: "Adosadas/Hilera",
          },
          ratioOfHybridvsAir: {
            title: "Proporción de Bombas de Calor Híbridas vs. Bombas de Calor de Aire (%)",
            labelA: "Híbridas",
            labelB: "Bomba de Calor de Aire",
          },
          ratioOfHighTemp: {
            title: "Proporción de Bombas de Calor de Aire de Alta Temperatura (HT) vs. Baja Temperatura (LT) (%)",
            labelA: "HT",
            labelB: "LT",
          },
          percentageOfPeopleWhoInstall: {
            title: "Porcentaje de personas que instalan una bomba de calor por año (%)",
            labelA: "Probabilidad",
          },
        },
      },
      charts: {
        loadProfiles: {
          title: "Perfiles Típicos de Carga (kW) de las Bombas de Calor por vivienda y tipo de bomba de calor",
          label: "Perfiles de Carga de Bombas de Calor",
          xAxis: "Hora del Día",
          yAxis: "Carga de Bomba de Calor (kW)",
          vAxes: {
            0: { title: "Carga de Bomba de Calor (kW)" },
          },
        },
        HPLoadChart: {
          title: "Perfil de Carga Estimado (kVA) de la bomba de calor por modelo",
          label: "Análisis de Carga de Bomba de Calor",
          xAxis: "Hora del Día",
          yAxis: "Carga de Bomba de Calor (kVA)",
          vAxes: {
            0: { title: "Carga de Bomba de Calor (kVA)" },
          },
          labelA: "Marca de Tiempo",
          labelB: "Carga de Bomba de Calor (KVa)",
        },
        powerModel: {
          title: {
            0: "Análisis de Carga/Disponibilidad de Energía del Transformador [",
            1: " ]",
          },
          label: "Carga del Transformador",
          xAxis: "Hora del Día",
          yAxis: "Carga (kVa)",
          data: {
            0: "Marca de Tiempo",
            1: "Carga (KVa)",
          },
          vAxes: {
            0: { title: "Carga (kVa)" },
            1: { title: "Disponibilidad (kVa)" },
          },
          labelA: "Hora del Día",
          labelB: "Carga Total",
          labelC: "Disponibilidad",
        },
        HPModel: {
          title: "Número Máximo Adicional de Bombas de Calor en este Transformador",
          label: "Análisis de Capacidad de Bombas de Calor",
          xAxis: "Hora del Día",
          yAxis: "# Bombas de Calor",
          vAxes: {
            0: { title: "# Bombas de Calor" },
            1: { title: "MAX_BOMBAS = " },
          },
          labelA: "Marca de Tiempo",
          labelB: "Número Máximo de Bombas de Calor",
        },
        HPCalculatedSales: {
          title: "Predicción de Nuevas Bombas de Calor por Año en este Transformador",
          label: "Ventas Anuales de Bombas de Calor Calculadas",
          xAxis: "Año",
          yAxis: "# Total de Nuevas Bombas de Calor",
          vAxes: {
            0: { title: "# Total de Nuevas Bombas de Calor" },
          },
          hAxis: {
            title: "Año",
          },
          labelA: "Año",
          labelB: "Número de Bombas de Calor",
        },
      },
    },
    InputSelectVT: {},
    KPIReport: {},
    LineChart: {},
    LineChartVT: {},
    LoaderVT: {},
    MapInfoWindow: {},
    MapInfoWindowPowerdataTemplate: {},
    MapInfoWindowTemplate: {},
    MapMarkerVT: {},
    MapsVT: {},
    MapTooltipVT: {},
    MinMaxChart: {},
    NavBar: {},
    OverviewCardsVT: {},
    PageHeader: {},
    POISnapshot: {},
    PowerDataMainReport: {
      title: "Aquí está el informe de hoy de VT Electron",
      tables: {
        fleetStatus: {
          title: "Estado de la Flota",
          columns: {
            issue: {
              text: "Problema",
            },
            numberOfAssets: {
              text: "Número de Activos",
            },
            percentageDevices: {
              text: "%",
            },
          },
        },
        devices: {
          columns: {
            name: {
              text: "Nombre",
            },
            transformerSize: {
              text: "Tamaño del Transformador",
            },
            maxCapacity: {
              text: "Capacidad Máxima",
            },
            maxCurrent: {
              text: "Corriente Máxima PH1-PH2-PH3",
            },
            maxTemperature: {
              text: "Temp. Máxima",
            },
            graph: {
              text: "",
            },
          },
        },
      },
    },
    PrimaryFiltersVT: {},
    RadialChartVT: {},
    ReportManagement: {},
    SecondaryFiltersVT: {},
    SelectVT: {},
    SnackBarVT: {},
    TooltipVT: {},
  },
};
